import { connect } from "react-redux";

const mapStateToProps = (state) => ({
    uploadPending: state.events.uploadPending
});

function FullPageLoader(props) {
  // return props.uploadPending ? (
  //   <div className="full-page-loader"></div>
  // ) :  null;
  return null;
}

export default connect(mapStateToProps)(FullPageLoader);